// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  env: 'deployed',
  production: false,
  useLocalFunctions: false,
  useLocalFirestore: false,
  firebase: {
    apiKey: 'AIzaSyBKQovDazueJvItU4cehWu_1_XKBwcruXY',
    authDomain: 'little-sis-cloud-sync.firebaseapp.com',
    projectId: 'little-sis-cloud-sync',
    storageBucket: 'little-sis-cloud-sync.appspot.com',
    messagingSenderId: '329688265315',
    appId: '1:329688265315:web:edb7dea16186980fc9be56',
  },
  storage: {
    bucketname: 'ls-sync-uploads',
    actions: 'ls-sync-actions',
    analysis: 'ls-sync-staged-analysis',
    logs: 'ls-sync-logs',
    guardian_analysis: 'ls-sync-staged-guardian-analysis',
    guardian_sync_actions: 'ls-sync-guardian-actions',
  },
  features: {
    userlane: true
  },
  googleClassroom: {
    managedClassroomAliasPrefix: 'd:LS_'
  },

  licensing: {
    toolLicenseKeys: [
      'ait-lsp'
    ],
    showLicenseTestPanel: false,
    useTestResponse: false
  },

    support: {
      email:'support@amplifiedit.com',
      feedbackFormLink: 'http://bit.ly/labsfeaturerequests',
      supportLink: 'https://amplifiedlabs.zendesk.com/hc/en-us/requests/new',
      helpCenterLink: 'https://amplifiedlabs.zendesk.com/hc/en-us/categories/1500001382321-Little-SIS-Premium',
      teacherReviewFeedbackFormLink: 'https://collab.amplifiedit.com/forum/52-feature-requests'
    },


  urls: {
    external: {
      littleSisWeb: 'https://littlesis.amplifiedlabs.xyz',
      renew: 'https://mail.google.com/mail/?view=cm&source=mailto&to=accounts@amplifiedit.com&su={app_name}%20renewal%20for%20{domain}&body=I%E2%80%99d%20like%20to%20request%20a%20renewal%20quote%20for%20{app_name}%20for%20domain%2C%20{domain}.%0D%0A%0D%0AThank%20you%2C%0D%0A%0D%0A{user_name}',
      trialRequest: 'https://www.amplifiedit.com/chargify-quote-request/?SKU=AIT-LSP',
      helpCenter: `https://amplifiedlabs.zendesk.com/hc/en-us/categories/1500001382321-Little-SIS-Premium`,
      deletionRequest: 'https://docs.google.com/forms/d/e/1FAIpQLScREmQ0FIrRX-Rrz8XEPuy59I1tK6km7PgQ0J2TYv_XWTaP4g/viewform',
    },
    services : {
      auditLogs: {
        create: 'https://saas-audit-log-api-6xbvwuiozq-uc.a.run.app/api/audit-log/create'
      },
      sso: 'https://littlesis.amplifiedlabs.xyz/#/?sso',
      guardians: {
        find: `Guardians-findGuardianData`,
      },
      syncHistory: {
        find: `syncHistory-findJobData`,
      },
      licensing:  'https://us-central1-labs-licensing.cloudfunctions.net/v2-checkLicense_dev', //TODO GET FINAL URL
    }
  },

  dwd: {
    lsc: {
      client_name: '105054791314183467488',
      scopes: 'https://www.googleapis.com/auth/admin.directory.group.readonly,'
        + ' https://www.googleapis.com/auth/admin.directory.orgunit.readonly,'
        + ' https://www.googleapis.com/auth/admin.directory.user.readonly,'
        + ' https://www.googleapis.com/auth/classroom.courses,'
        + ' https://www.googleapis.com/auth/classroom.rosters,'
        + ' https://www.googleapis.com/auth/classroom.announcements.readonly,'
        + ' https://www.googleapis.com/auth/classroom.coursework.students.readonly,'
        + ' https://www.googleapis.com/auth/classroom.guardianlinks.students,'
        + ' https://www.googleapis.com/auth/classroom.push-notifications'
    },
    sync: {
      client_names: {
        default: '112491376856516278882',
        prod1: '111976036291881586641',
        prod2: '109361245505548848077',
        prod3: '106867834408943935114',
        prod4: '110372122665771763178',
        prod5: '113271329810958433195'
      },
      scopes: 'https://www.googleapis.com/auth/admin.directory.user.readonly,'
        + ' https://www.googleapis.com/auth/script.storage,'
        + ' https://www.googleapis.com/auth/userinfo.email,'
        + ' https://www.googleapis.com/auth/script.external_request,'
        + ' https://www.googleapis.com/auth/script.scriptapp,'
        + ' https://www.googleapis.com/auth/classroom.courses,'
        + ' https://www.googleapis.com/auth/classroom.rosters,'
        + ' https://www.googleapis.com/auth/classroom.coursework.students.readonly,'
        + ' https://www.googleapis.com/auth/classroom.guardianlinks.students,'
        + ' https://www.googleapis.com/auth/classroom.profile.emails'
    }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
